import audioPlayer from '../../../../../../src/js/modules/audioPlayer';

window.addEventListener('load', () => {
    audioPlayer.init();
});
